import type { CancelReason } from '~/domain/Assegurou/cancelAssurantService';
import type { HiredInsuranceProductType } from '~/domain/Assegurou/contractedServices';
import type { CancelReasonsAssurantServiceResponseDTO } from '~/dto/Assegurou/cancelAssurantService';
import { cancelReasonDTOtoCancelReason } from '~/mappers/Assegurou/cancelAssurantService';
import apiAssegurou from '~/services/apiAssegurou';

export async function getCancelReasonsUseCase(
  produtCode: HiredInsuranceProductType
): Promise<CancelReason[] | []> {
  try {
    const response =
      await apiAssegurou.get<CancelReasonsAssurantServiceResponseDTO>(
        `/v1/Protecao/ListarMotivoCancelamento?codigoProduto=${produtCode}`
      );

    return response.data.resultData?.map(cancelReasonDTOtoCancelReason) || [];
  } catch {
    return [];
  }
}
